import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

/**
 * SubSettingsShell — iOS-consistent header + max-560 body used by every
 * sub-settings screen (BlockedUsers, MyReports, FollowRequests, etc.).
 *
 * Header: 52px, ChevronLeft back button on the left, centred title in
 * Plus Jakarta Sans 17px.  Body: `flex-1 overflow-y-auto` centred at
 * max-w-[560px] with 16px horizontal padding.
 */
export default function SubSettingsShell({
  title,
  subtitle,
  children,
  testId,
  onBack,
}) {
  const navigate = useNavigate();
  const back =
    onBack || (() => (window.history.length > 1 ? navigate(-1) : navigate("/settings")));

  return (
    <div
      className="min-h-[100dvh] w-full bg-background text-foreground flex flex-col"
      data-testid={testId}
    >
      <div
        className="h-[52px] px-2 flex items-center border-b border-border shrink-0"
        style={{ paddingTop: "env(safe-area-inset-top)" }}
      >
        <button
          type="button"
          onClick={back}
          className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-secondary transition-colors"
          aria-label="Back"
          data-testid={`${testId}-back`}
        >
          <ChevronLeft size={25} strokeWidth={2.4} />
        </button>
        <h1
          className="flex-1 text-center text-foreground font-jakarta font-bold text-[17px] pr-10"
          style={{ letterSpacing: "-0.3px" }}
          data-testid={`${testId}-title`}
        >
          {title}
        </h1>
      </div>
      <div className="flex-1 overflow-y-auto px-4 pt-4 pb-10">
        <div className="mx-auto w-full max-w-[560px]">
          {subtitle && (
            <p className="text-muted-foreground text-[13.5px] leading-5 mb-4">
              {subtitle}
            </p>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}
